<template>
  <div v-loading="saveAsLoading" style="padding: 20px">
    <el-form
      ref="addFormRef"
      :model="addForm"
      label-width="120px"
      :rules="addFormRoles"
    >
      <el-form-item :label="$t('message.table.projectName')" prop="name">
        <el-input v-model="addForm.name" size="small"></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.table.des')" prop="description">
        <el-input
          type="textarea"
          v-model="addForm.description"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.button.projectStatus')">
        <el-select v-model="templateVal" size="small">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">{{
        $t("message.button.cancel")
      }}</el-button>
      <el-button type="primary" @click="addSaveAs" size="small">{{
        $t("message.button.affirm")
      }}</el-button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      addForm: {},
      templateVal: "3",
      saveAsLoading: false,

      addFormRoles: {
        name: [
          {
            required: true,
            message: this.$t("message.tips.inputName"),
            trigger: "blur",
          },
          {
            min: 3,
            max: 25,
            message: this.$t("message.warning.length_101"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    statusList() {
      const { columnInfo } = this.$store.state.project.pageOne;
      const { listEntries } = columnInfo;
      const arr = Object.entries(listEntries["501"]).map((i) => {
        const [value, label] = i;
        return { value, label };
      });
      return arr;
    },
  },
  mounted() {
    console.log("this.statusList", this.statusList);
  },
  methods: {
    saveAsTemplete() {},
    cancel() {
      this.$emit("close");
    },
    addSaveAs() {
      this.saveAsLoading = true;
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) {
          this.saveAsLoading = false;
          return;
        }
        const obj = {
          ...this.$store.state.objectId,
        };
        this.addForm.objectId = obj;
        //对象生成模板 1生成模板，2生成项目
        this.addForm.createType = 1;
        this.addForm.template = this.templateVal;

        axios
          .post("/ppm/project/createTempleteOrObj", this.addForm)
          .then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              //this.$message.success(res.data.message)
              this.$message.success(this.$t("message.success.actions"));
              // this.btnLoading = false;
              this.addForm = {};
              this.templateVal = "3";
              this.$emit("close");
              const { ...obj } = res.data.object;
              this.getLink(obj);
            }
          })
          .finally(() => {
            this.saveAsLoading = false;
            // this.saveAsDialogVisible = false;
          });
      });
    },
  },
};
</script>